import { render } from "./StyleguideTableOptionsList.pug?vue&type=template&id=5db8e82f&lang=pug"
import script from "./StyleguideTableOptionsList.js?vue&type=script&lang=js"
export * from "./StyleguideTableOptionsList.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__